const linkedInIcon = `
<svg class="linkedin-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
  <circle fill="none" stroke-width="2" cx="20" cy="20" r="19"/>
<path d="M14.4,12.2c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2S14.4,11,14.4,12.2z M14.4,16.1h-4.3V30h4.3V16.1z   M20.4,16.1H16V30h4.3v-7.3c0-4.1,5.2-4.4,5.2,0V30h4.3v-8.8c0-6.9-7.8-6.6-9.6-3.2C20.4,18,20.4,16.1,20.4,16.1z"/>
</svg>
`
export default linkedInIcon
